import dayjs from 'dayjs'
import httpRequest from 'httpRequest'
import {
    ActionRecoveryLookupContract,
    CompletableContract,
    EventRouteActionLogContract,
} from 'models'
import {
    CloneEventRouteContract,
    EventRouteSettingContract,
    EventRouteSettingSlimModel,
} from 'models'

const ROUTE_PREFIX = '/location/event-routes'

const eventRouteSettingService = {
    getEventRouteSettings() {
        return httpRequest.get<EventRouteSettingSlimModel[]>(ROUTE_PREFIX)
    },
    getEventRouteSetting(eventRouteSettingId: string) {
        return httpRequest.get<EventRouteSettingContract>(
            `${ROUTE_PREFIX}/${eventRouteSettingId}`,
        )
    },
    getEventRouteLog(
        eventRouteSettingId: string,
        from: dayjs.Dayjs,
        to: dayjs.Dayjs,
        actionType: string,
        isSuccess?: boolean,
    ) {
        return httpRequest.get<EventRouteActionLogContract[]>(
            `${ROUTE_PREFIX}/logs/${eventRouteSettingId}`,
            {
                params: {
                    from: from.toISOString(),
                    to: to.toISOString(),
                    actionType,
                    isSuccess,
                },
            },
        )
    },
    createEventRouteSetting(data: EventRouteSettingContract) {
        return httpRequest.post(ROUTE_PREFIX, data)
    },
    updateEventRouteSetting(
        eventRouteSettingId: string,
        data: EventRouteSettingContract,
    ) {
        return httpRequest.put(`${ROUTE_PREFIX}/${eventRouteSettingId}`, data)
    },
    deleteEventRouteSettings(eventRouteSettingIds: string[]) {
        return httpRequest.delete(ROUTE_PREFIX, {
            params: { eventRouteSettingIds },
        })
    },
    resetEventRouteSettings() {
        return httpRequest.post(`${ROUTE_PREFIX}/reset`)
    },
    sendEventActionAck(
        eventRouteActionLogId: string,
        actionName: string,
        isSuccess: boolean,
        failedReason?: string,
    ) {
        return httpRequest.post(
            `${ROUTE_PREFIX}/ack/${eventRouteActionLogId}`,
            {
                actionName,
                isSuccess,
                failedReason,
            },
        )
    },
    cloneEventRouteSetting(payload: CloneEventRouteContract) {
        return httpRequest.post<EventRouteSettingSlimModel>(
            `${ROUTE_PREFIX}/clone`,
            payload,
        )
    },
    countNumberOfRecoverableActions() {
        return httpRequest.get<number>(`${ROUTE_PREFIX}/recovery/count`)
    },
    getRecoverableActions() {
        return httpRequest.get<ActionRecoveryLookupContract[]>(
            `${ROUTE_PREFIX}/recovery`,
        )
    },
    retryAction(actionRecoveryID: string) {
        return httpRequest.post<CompletableContract>(
            `${ROUTE_PREFIX}/recovery/${actionRecoveryID}`,
        )
    },
}

export default eventRouteSettingService
